import { render, staticRenderFns } from "./Privacy_202411.vue?vue&type=template&id=62bb4c76&scoped=true"
import script from "./Privacy_202411.vue?vue&type=script&lang=js"
export * from "./Privacy_202411.vue?vue&type=script&lang=js"
import style0 from "./Privacy_202411.vue?vue&type=style&index=0&id=62bb4c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb4c76",
  null
  
)

export default component.exports